export default function (variableName) {
  return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim()
}
